module.exports = __webpack_public_path__ + "static/bentonsanscond-light-webfont-bd4d8e99e667c642c922d89c069b85bc.woff";